import { render, staticRenderFns } from "./InstructorCourseDashboard.vue?vue&type=template&id=3ccd70d6&"
import script from "./InstructorCourseDashboard.vue?vue&type=script&lang=ts&"
export * from "./InstructorCourseDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./InstructorCourseDashboard.vue?vue&type=style&index=0&id=3ccd70d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports